module.exports = __webpack_public_path__ + "img/uber.6569573d.png";